<div class="pill-bar" [class.compact]="compact" [style]="customStyle">
  @if (endCaps) {
    <div class="pill end-cap" (click)="previous()">
      <span class="icon-arrow-left"></span>
    </div>
  }
  @for (item of items; track item) {
    <div class="pill" [class]="{'selected': item === selectedItem}" (click)="select(item)">
    {{item}}@if (compact) {<span class="pill-total"> of {{items.length}}</span>}</div>
  }
  @if (endCaps) {
    <div class="pill end-cap" (click)="next()">
      <span class="icon-arrow-right"></span>
    </div>
  }
</div>
